import React from "react";
import "./../attendance.css";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";

const AttendanceTable = ({ attendance, onView, selectedDate }) => {
  const navigate = useNavigate();
  const getStatus = (item) => {
    if (!item.checkInTime) {
      return <span className="badge bg-danger-subtle text-danger">Absent</span>;
    }

    if (!item.checkOutTime) {
      return (
        <span className="badge bg-primary-subtle text-primary">Working</span>
      );
    }

    return (
      <span className="badge bg-success-subtle text-success">Present</span>
    );
  };

  return (
    <div className="table-responsive">
      <table
        className="table table-hover align-middle table-bordered"
        id="commontable"
      >
        <thead className="theadheading">
          <tr>
            <th>Employee</th>
            <th>Agent</th>
            <th>Status</th>
            <th>Check In</th>
            <th>Check Out</th>
            <th className="text-center">Visits</th>
            <th className="text-center">Distance</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>

        <tbody>
          {attendance.length > 0 ? (
            attendance.map((item) => (
              <tr key={item.employeeId}>
                <td>
                  <span className="fw-semibold">{item.employeeId}</span>
                </td>

                <td>
                  <div className="d-flex align-items-center">
                    {/* <div className="agent-avatar">
                      {item.name?.charAt(0)?.toUpperCase()}
                    </div> */}

                    <div className="ms-3">
                      <div className="fw-semibold">{item.name}</div>

                      <small className="font-weight-bold">
                        {item.designation}
                      </small>
                    </div>
                  </div>
                </td>

                <td>{getStatus(item)}</td>

                <td>
                  {item.checkInTime
                    ? moment.utc(item.checkInTime).local().format("hh:mm A")
                    : "-"}
                </td>

                <td>
                  {item?.checkOutTime && moment(item.checkOutTime).isValid()
                    ? moment.utc(item.checkOutTime).local().format("hh:mm A")
                    : "-"}
                </td>

                <td className="text-center">
                  <span className="badge bg-success-o-95 rounded-pill">
                    {item.visitCount}
                  </span>
                </td>

                <td className="text-center">
                  <span className="fw-semibold">
                    {item.distanceKm?.toFixed(2)} km
                  </span>
                </td>

                <td className="text-center">
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() =>
                      navigate(`/attendance/${item.employeeId}`, {
                        state: {
                          date: selectedDate.format("YYYY-MM-DD"),
                        },
                      })
                    }
                  >
                    <i className="bi bi-eye me-1"></i>
                    Details
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center py-5 text-muted">
                <i className="bi bi-calendar-x fs-2 d-block mb-2"></i>
                No attendance found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceTable;
